import React, { useState } from "react";

const HighGizmo = ({isOpen}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{ cursor: "pointer" }}
      // onMouseEnter={() => setIsHovered(true)}
      // onMouseLeave={() => setIsHovered(false)}
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <circle cx="11" cy="11" r="11" fill="#FF6600"/>
</svg>
    </div>
  )
}

export default HighGizmo